import React, { useState, useMemo } from "react";
import { PRICE_TABLE } from "../../mock/mockData";

const PriceTable = () => {
  const [filter, setFilter] = useState("Todos");

  const groups = useMemo(() => {
    if (filter === "Todos") return PRICE_TABLE;
    return PRICE_TABLE.filter((g) => g.group === filter.toUpperCase());
  }, [filter]);

  return (
    <section id="tabela" className="border-t-[3px] border-black">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-5">
            <span className="mono text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">05</span>
            <span className="mono text-[11px] uppercase tracking-widest text-black/60">Tabela · 05/05/2026</span>
            <div className="flex-1 h-[3px] bg-black" />
          </div>
          <h2 className="display font-bold text-[36px] sm:text-[56px] md:text-[80px] lg:text-[96px] leading-[0.9]">
            Preços <span className="italic font-normal">revendedor</span>.
            <br />
            Toda a gama,
            <br />
            todas as voltagens.
          </h2>
          <p className="mt-6 max-w-[700px] text-[15px] md:text-[17px] leading-[1.5]">
            Preço cliente final é sugerido. Carregador incluído em todos os modelos. Margem mostrada é por unidade.
            Entrega é calculada à parte conforme volume e distância, e conforme o produto segue na caixa ou montado.
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-6">
          {["Todos", "Power", "Nice", "Briza"].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`mono text-[12px] uppercase font-medium tracking-wider px-4 py-2 brut-border brut-btn ${
                filter === f ? "bg-black text-[#FFD60A]" : "bg-white"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="brut-border-thick bg-white overflow-x-auto">
          <table className="w-full text-left min-w-[680px]">
            <thead>
              <tr className="bg-black text-[#FFD60A] mono text-[11px] uppercase tracking-widest">
                <th className="p-4 border-r-[3px] border-[#FFD60A]/30">Modelo · Bateria de Lítio</th>
                <th className="p-4 border-r-[3px] border-[#FFD60A]/30">Preço revendedor</th>
                <th className="p-4 border-r-[3px] border-[#FFD60A]/30">PVP sugerido</th>
                <th className="p-4 border-r-[3px] border-[#FFD60A]/30">Margem</th>
                <th className="p-4">Carregador</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((g) => (
                <React.Fragment key={g.group}>
                  <tr className="bg-[#FFD60A]">
                    <td colSpan={5} className="p-3 mono text-[12px] uppercase font-bold tracking-widest border-y-[3px] border-black">
                      ▮ {g.group}
                    </td>
                  </tr>
                  {g.rows.map((r, i) => (
                    <tr
                      key={r.spec}
                      className={`border-b-[2px] border-black/10 hover:bg-[#F4F0E8] transition-colors ${
                        i % 2 === 0 ? "bg-white" : "bg-[#FAF7EF]"
                      }`}
                    >
                      <td className="p-4 text-[14px] font-medium">{r.spec}</td>
                      <td className="p-4 mono text-[14px] font-bold">{r.dealer}</td>
                      <td className="p-4 mono text-[14px]">{r.pvp}</td>
                      <td className="p-4 mono text-[14px] font-bold text-[#E63946]">{r.margin}</td>
                      <td className="p-4 mono text-[13px]">{r.charger}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-5 flex flex-wrap gap-x-6 gap-y-1 mono text-[11px] uppercase tracking-widest text-black/60">
          <span>• Preços em euros</span>
          <span>• IVA e transporte não incluídos</span>
          <span>• Entrega calculada por volume e distância</span>
          <span>• Produto na caixa ou montado altera o valor logístico</span>
          <span>• Tabela válida desde 05/05/2026</span>
          <span>• Carregador incluído em todos os modelos</span>
        </div>
      </div>
    </section>
  );
};

export default PriceTable;
